export const en = {
	"navigation.users": "Users",

	"title": "Product Catalogue of {{brand}}",

	"models.title": "Designs",
	"lenses.title": "Lens Colors",
	"plasticcolors.title": "Frame Colors",

	"model.subtitle": "by {{brand}}",

	"tryon": "Try-On",
	"duplicate": "Duplicate",
	"edit": "Edit",
	"delete": "Delete",
	"cancel": "Cancel",
	"submit": "Submit"
};